// Type-only: tests mock `@react-google-maps/api` down to `useLoadScript`, so a runtime import here would be undefined.
import type { Libraries } from "@react-google-maps/api";
import { getGoogleApiKey } from "@/helpers/apiHelpers";

/**
 * Maps JS answers in this language. Left unset, Google answers in the browser's: a Japanese-locale browser
 * autocompleting "1 Martin Place Sydney" got "… NSW 2000 オーストラリア", and that string was saved on the
 * booking. Pinned to English so every saved address is too (DEV-1826).
 */
export const GOOGLE_MAPS_LANGUAGE = "en";

/**
 * The options for every `useLoadScript` in the app. @react-google-maps/api loads Maps JS once and requires
 * identical options from every caller, so they all pass this one object as is — never a second loader or
 * a hand-copied or extended set of options. `usePlaces` loads through react-google-autocomplete instead,
 * which reuses a Maps script already on the page (the reverse is not true), so it passes
 * `GOOGLE_MAPS_LANGUAGE` too: whichever loads first, the script asks for English.
 */
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: getGoogleApiKey(),
  libraries: ["places"] as Libraries,
  language: GOOGLE_MAPS_LANGUAGE,
};
